import api from '@/api'

const { $pricing, $student, $core } = api;
export const { $types, $scholarships, $products, $documentations } = $pricing;
export const { $studentsWithoutScholarship } = $student;
export const { $users } = $core;
